<template>
  <div id="app">
    <div class="site-container">
      <page-header></page-header>

      <div :class="wrapperClass">
        <router-view name="sidebar"></router-view>
        <router-view></router-view>
      </div>
    </div>

    <cookie-consent @on-accept="cookieConsentAccepted"></cookie-consent>
    <home-screen-drawer ref="homeScreenDrawer"></home-screen-drawer>

    <page-footer></page-footer>
  </div>
</template>

<script>
  import CookieConsent from './components/CookieConsent.vue'
  import HomeScreenDrawer from './components/HomeScreenDrawer.vue'
  import PageHeader from './components/PageHeader.vue'
  import PageFooter from './components/PageFooter.vue'

  export default {
    watch: {
      $route () {
        this.wrapperClass = this.$route.meta.wrapperClass || null
      }
    },

    data: () => ({
      wrapperClass: null
    }),

    components: {
      CookieConsent,
      HomeScreenDrawer,
      PageHeader,
      PageFooter
    },

    methods: {
      cookieConsentAccepted () {
        this.$refs.homeScreenDrawer.init()
      }
    }
  }
</script>

<style src="./styles/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?550fb799